// extracted by mini-css-extract-plugin
export var askAiIcon = "_mr-j";
export var category = "_mr-9";
export var categoryHeader = "_mr-e";
export var container = "_mr-0";
export var group = "_mr-a";
export var groupItems = "_mr-f";
export var groupSeparator = "_mr-k";
export var loading = "_mr-1";
export var noResults = "_mr-3";
export var placeholder = "_mr-2";
export var resultContent = "_mr-5";
export var resultIcon = "_mr-c";
export var resultItem = "_mr-g";
export var resultMeta = "_mr-8";
export var resultSubtitle = "_mr-7";
export var resultSuffix = "_mr-i";
export var resultTitle = "_mr-6";
export var resultsList = "_mr-4";
export var searchGroup = "_mr-d";
export var selected = "_mr-h";
export var subgroup = "_mr-b";